import { KitTableMessages } from "@/messages/products/kit-table.messages";

export const KITS_TABLE_COLUMNS = (messages: KitTableMessages) => {
  return [messages.titleColumn, messages.quantityColumn, messages.optionsColumn];
};
